import { useCallback } from 'react';
import type { FormField } from '@elfsight/widget-form-builder/widget';
import {
  DATA_SERVICE_URL,
  Form as FormContainer
} from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import { useEmailSubmitPopup } from '../../../use-email-submit-popup';
import { FormLayout } from './form-layout';
import { useEmailSubmitFormSettings } from './use-email-submit-form-settings';

const CLOSE_POPUP_ACTIONS = ['hide', 'redirect'];

export type FormProps = {
  fields: FormField[];
};

export function Form({ fields }: FormProps) {
  const { t } = useLingui();

  const { submitAction, language } = useSettings();

  const { closeFormPopup } = useEmailSubmitPopup();
  const formSettings = useEmailSubmitFormSettings(fields);

  const onFormSubmit = useCallback(() => {
    if (CLOSE_POPUP_ACTIONS.includes(submitAction)) {
      closeFormPopup();
    }
  }, [closeFormPopup, submitAction]);

  return (
    <FormContainer
      {...formSettings}
      onSubmitSuccessful={onFormSubmit}
      submitUrl={`${DATA_SERVICE_URL}/public/resources/form-submissions/`}
      submitError={t`An error occurred when submitting the form, please try again later`}
      consentValues={[t`Yes`, t`No`]}
      widgetLanguage={language.language}
    >
      <FormLayout fields={fields} />
    </FormContainer>
  );
}
